import {
    getLang
} from '../../util/i18n.js'
import {
    getHomeTexts
} from '../../data/homeTexts.js'

export const initHomeI18n = () => {
    const lang = getLang()
    const t = getHomeTexts(lang)

    const i18nElements = document.querySelectorAll('[data-i18n]')

    i18nElements.forEach((el) => {
        const key = el.getAttribute('data-i18n')
        if (!key) return
        const keys = key.split('.')
        let value = t

        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k]
            } else {
                value = null
                break
            }
        }

        if (value && typeof value === 'string') {
            const attr = el.getAttribute('data-i18n-attr')
            if (attr) {
                el.setAttribute(attr, value)
            } else {
                el.textContent = value
            }
        }
    })
}